import React, { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Select } from "../../../components/form";
import { Button } from "../../../components/button";
import {
  UserRole,
  OrderStatus,
  PaymentStatus,
  DeliveryStatus,
  DeliveryFeeOrigin,
} from "../../../__generated__/globalTypes";
import { useUsers } from "../../users/hooks";
import { useMe } from "../../users/hooks/useMe";
import { CustomerSelectSearch } from "../../customers/components";
import {
  orderStatusLabel,
  paymentStatusLabel,
  deliveryStatusLabel,
  deliveryFeeOriginLabel,
} from "../../../helpers/enum-labels";

interface IOrderForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
  isEditing?: boolean;
}

export const OrderForm: React.FC<IOrderForm> = ({ loading, form, submit, isEditing }) => {
  const { data: usersData } = useUsers({ where: {}, limit: 100, offset: 0 });
  const { data: meData } = useMe();

  const isAdmin = meData?.me?.role === UserRole.Admin;

  useEffect(() => {
    if (!isEditing && meData?.me?.id && !form.getValues("salesRepId")) {
      form.setValue("salesRepId", meData.me.id);
    }
  }, [meData, isEditing]);

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input label="Numéro" className="w-full" {...form.register("number")} placeholder="Optionnel" />
        <CustomerSelectSearch form={form} name="customerId" />
        <Select
          label="Commercial"
          className="w-full"
          value={form.watch("salesRepId") ?? ""}
          disabled={!isAdmin}
          {...form.register("salesRepId", { required: true, valueAsNumber: true })}
        >
          <option value="">-</option>
          {usersData?.users?.results?.map((user) => (
            <option key={user.id} value={user.id}>
              {user.firstname} {user.lastname}
            </option>
          ))}
        </Select>
        <Select
          label="Statut"
          className="w-full"
          value={form.watch("status") ?? ""}
          {...form.register("status", { required: true })}
        >
          {Object.keys(OrderStatus).map((status) => (
            <option key={status} value={status}>
              {orderStatusLabel(status)}
            </option>
          ))}
        </Select>
        <Select
          label="Statut de paiement"
          className="w-full"
          value={form.watch("paymentStatus") ?? ""}
          {...form.register("paymentStatus", { required: true })}
        >
          {Object.keys(PaymentStatus).map((status) => (
            <option key={status} value={status}>
              {paymentStatusLabel(status)}
            </option>
          ))}
        </Select>
        <Select
          label="Statut de livraison"
          className="w-full"
          value={form.watch("deliveryStatus") ?? ""}
          {...form.register("deliveryStatus", { required: true })}
        >
          {Object.keys(DeliveryStatus).map((status) => (
            <option key={status} value={status}>
              {deliveryStatusLabel(status)}
            </option>
          ))}
        </Select>
        <Select
          label="Origine des frais de livraison"
          className="w-full"
          value={form.watch("deliveryFeeOrigin") ?? ""}
          {...form.register("deliveryFeeOrigin", { required: true })}
        >
          {Object.keys(DeliveryFeeOrigin).map((origin) => (
            <option key={origin} value={origin}>
              {deliveryFeeOriginLabel(origin)}
            </option>
          ))}
        </Select>
        <Input
          label="Livraison prévue"
          type="date"
          className="w-full"
          value={form.watch("plannedDeliveryAt") ?? ""}
          {...form.register("plannedDeliveryAt")}
        />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
